import Ticketlist from 'App/pages/ClientCard/ContentPages/Support/ClientContactCardTicketList';

angular.module('domain.account').controller('AccountSupport', [
	'$scope',
	function ($scope) {
		$scope.AccountSupport = Ticketlist;
	}
]);
